import React, { lazy } from 'react';
import styled from 'styled-components';
import NumberFormat from 'react-number-format';
import { Field } from 'react-final-form';

import { TextField as MuiTextField } from '@mui/material';

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;
  
  return (
    <NumberFormat
      {...other}
      min="0"
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isNumericString
    />
  );
}

const FormTextField = styled((props) => (
  <Field name={props.name}>
    {({ input, meta }) => (
      <>
        <MuiTextField
          {...input}
          variant="outlined"
          onChange={(e) => {
            if(props.disabled) return
            input.onChange(e.target.value)
            if (props.onChange) props.onChange(e.target.value)
          }}
          id="formatted-numberformat-input"
          InputProps={{
            inputComponent: NumberFormatCustom,
          }}
          {...props}
        />
        {meta.error && meta.touched && (
          <span
            style={{
              color: 'red',
              fontSize: '16px',
            }}
          >
            {meta.error}
          </span>
        )}
      </>
    )}
  </Field>
))`
  margin-bottom: ${(props) => props.mb || 0}px;
  width: 100%;

  .formControl {
    height: 40px;
  }
  .MuiOutlinedInput-input {
    padding: ${(props) => props.padding || '9px 10px 8px'};
  }
  .input {
    padding: 0;
    height: 40px;
    min-height: 40px;
    border-color: ${({theme}) => theme.palette.colors.gray200};
  }
  fieldset {
    top: 0;
    border-color: ${({theme}) => theme.palette.colors.gray200};
  }
  legend {
    display: none;
  }
`;

export default FormTextField;
